import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { GettingStarted, PrivateLayout, ResourceContent } from '../components';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { AppRootState, navigateToServiceRequest } from '../redux';
import DashboardTable from '../components/DashboardTable';

export const HomeView = () => {
  const dispatch = useDispatch();

  const renderButton = () => {
    const isStartNewRequestTextChangeEnabled = useSelector(
      (state: AppRootState) =>
        (state.app.entities.features?.['StartNewRequestTextEnhancement']?.data as any)?.enabled ?? false
    );

    const buttonNewText = useSelector(
      (state: AppRootState) =>
        (state.app.entities.resources?.['home.getting-started.widget1.action']?.data as any)?.content?.label
    );

    return (
      <>
        <FeatureGuard contentKey='service-request.manage'>
          <Button
            className='text-nowrap px-3'
            variant='secondary-new'
            size='sm'
            onClick={() => dispatch(navigateToServiceRequest())}
            data-testid='cmx__new-request-button'>
            <i className='fa-light fa-file-circle-plus me-2' />
            {isStartNewRequestTextChangeEnabled ? buttonNewText : 'Start a New Request'}
          </Button>
        </FeatureGuard>
      </>
    );
  };

  return (
    <>
      <FeatureGuard contentKey='home.layout'>
        <PrivateLayout
          pageTitle='dashboard'
          pageIcon={<i className='fa-light fa-dashboard me-2'></i>}
          subtoolbarChildren={renderButton()}>
          <div className='px-3'>
            <DashboardTable />
          </div>
        </PrivateLayout>
        {/* <PrivateLayout subtoolbarChildren={renderButton()}>
          <h3 className='text-primary'>
            <ResourceContent contentKey='home.title' />
          </h3>
          {/* <GettingStarted /> 
          <DashboardTable />
        </PrivateLayout> */}
      </FeatureGuard>
      {/* <DashboradTable /> */}
      <FeatureGuard contentKey='home-phyz.layout'>
        <PrivateLayout subtoolbarChildren={renderButton()} pageTitle='FRONT DESK'>
          <GettingStarted />
        </PrivateLayout>
      </FeatureGuard>
    </>
  );
};
